import React, { useState } from 'react'
import { Expaned, Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import { Popover } from 'antd'
import SearchInput from '@/components/search-input/search-input'
import classNames from 'classnames'
import Button from '@/components/button/button'
import './goods-shelf.scss'
import ShelfConfig from './modules/shelf-config/shelf-config'
import MallGoodGroup from './modules/good-group/good-group'
import MallGoodsTable from './modules/good-table/good-table'
import { goodsShelfStore } from './store/goods-shelf'

interface GoodsShelfProps {}

export const GoodsShelf: React.FC<GoodsShelfProps> = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('goods-shelf', e, m)
    const [visable, setVisable] = useState(false)
    const [keyWord, setKeyWord] = useState('')

    return (
        <Expaned className={getCls()}>
            <div className={getCls('header')}>
                <Popover
                    placement="bottomRight"
                    visible={visable}
                    onVisibleChange={() => setVisable(!visable)}
                    content={<ShelfConfig onClose={() => setVisable(false)} />}
                    trigger="click"
                >
                    <div>
                        <Button
                            types="more"
                            style={{
                                margin: '0 16px',
                            }}
                        >
                            货架设置
                        </Button>
                    </div>
                </Popover>
                <SearchInput
                    isExpaned={false}
                    placeholder="搜索"
                    onSearch={value => {
                        setKeyWord(value.trim())
                        goodsShelfStore.setKeyWord(value.trim())
                    }}
                    onDelete={() => {
                        setKeyWord('')
                        goodsShelfStore.setKeyWord('')
                    }}
                />
            </div>
            {keyWord && (
                <Row className={getCls('searchBox')}>
                    <div>
                        以下是
                        <span className={classNames('them-color')} data-padding-h-8>
                            {keyWord}
                        </span>
                        的搜索结果
                    </div>
                    <div
                        className={getCls('delete')}
                        onClick={() => {
                            setKeyWord('')
                            goodsShelfStore.setKeyWord('')
                        }}
                    >
                        <i data-cursor-pointer className="iconfont icon6guanbi-20" />
                    </div>
                </Row>
            )}
            <Expaned data-row className={getCls('content')}>
                <MallGoodGroup />
                <MallGoodsTable />
            </Expaned>
        </Expaned>
    )
}
